import { Button } from 'antd'
import React from 'react';

import './bookdeal.css'

export default function BookdealComponen({projectclass ,title ,imageurl, title1 ,subtitle , taglabel, setValue, taglabel1,cardType}) {
  return (
         <>    
         
        <div className={`projcard ${projectclass}`}>
      <div className="projcard-innerbox">
        <img className="projcard-img" src={imageurl} />
        <div className="projcard-textbox">

          <div className="projcard-subtitle">{title1}</div>
          <div className="projcard-bar"></div>
          <div className="projcard-description">{subtitle}</div>
         
          <div className="projcard-tagbox">
            <span className="projcard-tag">{taglabel}</span>
            <span className="projcard-tag">{taglabel1}</span>     
          
          {/* <Button type="primary" data-bs-toggle="modal" data-bs-target="#exampleModal">Book Now</Button> */}
          </div>
           <button type="button" class="btn- btn btn-primary " data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={()=>setValue("testType",cardType)}>
Book Now
</button>
        </div>
      </div>
    </div>


</>  
  )
}
